import { EntityType } from '@shared/models/entity-enum';

export enum FilterActions {
  HideShow,
  AddFilters,
  ClearFilters,
  ResetFilters,
}

export const AUDIT_HISTORY_FILTER_ACTIONS: { [key in FilterActions]?: boolean } = {
  [FilterActions.AddFilters]: false,
  [FilterActions.ClearFilters]: true,
  [FilterActions.HideShow]: false,
  [FilterActions.ResetFilters]: false,
};

// Could be used to override sorting configurations from BE
export const OVERRIDE_SORTABLE_COLUMNS: { [key: string]: boolean } = {};

export const RECORD_TYPE_TO_ENTITY_MAPPING: { [key: string]: EntityType } = {
  leaseComp: EntityType.LeaseComp,
  portfoliocomp: EntityType.PortfolioSale,
  saleComp: EntityType.SaleComp,
  tenant: EntityType.Tenancy,
  property: EntityType.Property,
  availability: EntityType.Availability,
  company: EntityType.Company,
  contact: EntityType.Contact,
  brand: EntityType.Brand,
  tim: EntityType.Tim,
  portfolioComp: EntityType.PortfolioSale,
};
